import React, { useState, useEffect } from "react";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { apiUrl } from "../../config/Config.js";
import { useDispatch } from 'react-redux';
import { Link } from "react-router-dom";
import { PhoneInput, defaultCountries } from "react-international-phone";
import "react-international-phone/style.css";
import { useLocation } from "react-router-dom";
import PhaseTwoSevaModal from "../../components/PhaseTwoSevaModal";

const MobileOTPVerify = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    mobile: "",
    password: ""
  });
  const [loading, setLoading] = useState(false);
  const [phaseTwoUser, setPhaseTwoUser] = useState(null);
  const [otptext, setotptext] = useState("");
  const { state } = useLocation();
  console.log('state >>', state);
  const dispatch = useDispatch(); 

  const indiaOnlyCountries = defaultCountries.filter(
    (country) => country[1] === "in"
  );

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const [otpSent, setOtpSent] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(120); // 2 minutes
  const [canResend, setCanResend] = useState(false);
  const [otperrormessage, setotperrormessage] = useState("");

  useEffect(() => {
    if (!otpSent) return;

    if (secondsLeft === 0) {
      setCanResend(true);
      return;
    }

    const timer = setInterval(() => {
      setSecondsLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [otpSent, secondsLeft]);

  const formatTime = (secs) => {
    const min = Math.floor(secs / 60);
    const sec = secs % 60;
    return `${min}:${sec < 10 ? "0" : ""}${sec}`;
  };

  const resendotpfunc = async() => {
    const { isValid, mobile } = normalizeAndValidateIndianMobile(state?.mobile);
    if (!isValid) {
      alert("Invalid mobile number");
      return;
    } else {
    }
    var data = {
    mobile: mobile
  }
  console.log('data >>', data);

  try {
    const res = await axios.post(
      apiUrl + "user-verify-resendotp-with-number",
      data,
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    );

    if (res.data.status === "success") {
      setSecondsLeft(120);
      setCanResend(false);

    } else {
      alert(res.data.message || "Something went wrong.");
    }
  } catch (err) {
    console.error(err);
    alert(
      "Error logging in: " +
        (err.response?.data?.message || err.message || "Network error.")
    );
  } finally {
    // setLoading(false);
  }
    
  }

  const normalizeAndValidateIndianMobile = (input) => {
    if (!input) return { isValid: false, mobile: '' };
  
    // remove spaces, hyphens, brackets, etc.
    let digits = String(input).replace(/\D/g, '');
  
    // remove country code 91 if present
    if (digits.startsWith('91')) {
      digits = digits.slice(2);
    }
  
    // remove leading zero
    if (digits.startsWith('0')) {
      digits = digits.slice(1);
    }
  
    // must be exactly 10 digits
    if (!/^[6-9]\d{9}$/.test(digits)) {
      return { isValid: false, mobile: '' };
    }
  
    return { isValid: true, mobile: digits };
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    var isotperror = false;
    if (!otptext) {
      // alert("Empty OTP");
      isotperror = true;
      setotperrormessage("OTP cannot be empty");
      return;
    } else {
      if(otptext?.length == 6) {
        isotperror = false;
        setotperrormessage("");
      } else {  
        isotperror = true;
        setotperrormessage("Invalid OTP");
        return;
      }
    }
    const { isValid, mobile } = normalizeAndValidateIndianMobile(state?.mobile);
    if (!isValid) {
      alert("Invalid mobile number");
      return;
    } else {
    }

    setLoading(true);
    var data = {
        otp: otptext,
        mobile: mobile
    }
    console.log('data >>', data);

    try {
      const res = await axios.post(
        apiUrl + "user-verify-otp-with-number",
        data,
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      if (res.data.status === "success") {
        dispatch({ type: "customerdata", payload: res.data.data })
        if (res.data.data?.show_phase_two_seva_offer) {
          setPhaseTwoUser(res.data.data);
        } else {
          navigate("/createstory");
        }

      } else {
        alert(res.data.message || "Login failed");
      }
    } catch (err) {
      console.error(err);
      alert(
        "Error logging in: " +
          (err.response?.data?.message || err.message || "Network error.")
      );
    } finally {
      setLoading(false);
    }
    setLoading(false);
  };

  const handleRegisterClick = () => {
    navigate("/register"); // change to your actual register route
  };

  useEffect(() => {
    setOtpSent(true);
    setSecondsLeft(120);
    setCanResend(false);
  }, [])

  return (
    <>
      <PhaseTwoSevaModal
        show={Boolean(phaseTwoUser)}
        user={phaseTwoUser}
        onContinue={() => navigate("/createstory")}
        onPaymentSuccess={() => {
          dispatch({
            type: "customerdata",
            payload: {
              ...phaseTwoUser,
              show_phase_two_seva_offer: false,
              phase_two_seva_contributed: true,
            },
          });
          navigate("/createstory");
        }}
      />
      <Helmet>
        {/* Meta Title */}
        <title>Login to TheOmSaga | Share Your Spiritual Stories</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Sign in to TheOmSaga to share your own spiritual stories, save the best spiritual stories you love and stay connected with a community of believers and seekers."
        />

        {/* Primary Keywords */}
        <meta
          name="keywords"
          content="spiritual stories, spiritual tale, spiritual story telling platform"
        />

        {/* Canonical Tag */}
        <link rel="canonical" href="https://theomsaga.com/login" />

        {/* Open Graph Tags */}
        <meta
          property="og:title"
          content="Login to TheOmSaga | Share Your Spiritual Stories"
        />
        <meta
          property="og:description"
          content="Sign in to TheOmSaga to share your own spiritual stories, save the best spiritual stories you love and stay connected with a community of believers and seekers."
        />
        <meta property="og:url" content="https://theomsaga.com/login" />
        <meta
          property="og:image"
          content="https://theomsaga.com/assets/images/login-banner.webp"
        />

        {/* Schema Markup */}
        <script type="application/ld+json">
          {`
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": "https://theomsaga.com/login#webpage",
      "name": "Login to TheOmSaga",
      "url": "https://theomsaga.com/login",
      "description": "Login to TheOmSaga to share spiritual stories, save inspirational spiritual tales, and stay connected with a community of faith and seekers.",
       "sameAs": [
                  "https://www.instagram.com/theomsaga20?igsh=MWNnN3E0NGVleTltZw==",
                  "https://www.facebook.com/share/1B44vEtGc7/"
                ]
     
     
      "isPartOf": {
        "@type": "WebSite",
        "name": "TheOmSaga",
        "url": "https://theomsaga.com"
      }
    }
    `}
        </script>
      </Helmet>

      <div className="login-page-container">
        <div className="login-page-scroll mobileotpverify-scroll">
          <div className="login-page-main-content">
            <div>
              <p className="onetime-text-login">
                One-time registration fee with lifetime access.
              </p>
              <p className="login-page-title">VERIFY OTP</p>
            </div>

            <form className="login-page-form" onSubmit={handleSubmit}>
              <PhoneInput
                defaultCountry="in"
                countries={indiaOnlyCountries}
                hideDropdown
                forceDialCode
                disableCountryGuess
                name="mobile"
                value={state?.mobile}
                // onChange={(e) => {
                //   setFormData({ ...formData, mobile: e });
                // }}
                disabled
                required
              />
              <input
              className="login-page-input otp-page-input"
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              placeholder="Enter OTP sent to your number"
              value={otptext}
              onChange={(e) => {
                const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                setotptext(onlyNumbers);
              }}
              maxLength={6}
            />
            {
                otperrormessage ?
                <div className="login-page-input-error-div">
                   <p className="register-error-message" style={{textAlign: 'left'}}>{otperrormessage}</p>
                </div>
                : null
              }
            <div className="forgetpassworddiv resetpassworddiv">
            {!canResend ? (
            <p style={{fontWeight: 400}}>
              Resend OTP in <strong>{formatTime(secondsLeft)}</strong>
            </p>
          ) : (
            <p onClick={() => {resendotpfunc()}}>Resend OTP</p>
          )}
              </div>
              <button
                className="login-page-button"
                type="submit"
                disabled={loading}
              >
                {loading ? "Verifying otp..." : "Verify OTP"}
              </button>

              {/* <div className="ormaindiv">
                <div className="orborder"></div>
                <div className="ortextdiv">
                  <p className="ortext">OR</p>
                </div>
                <div className="orborder"></div>
              </div> */}

              {/* <button
                className="login-page-button loginwithpasswordbtn"
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/login-with-password');
                  console.log('Hello')
                }}
              >
                Login with Password
              </button> */}
            </form>

            <div className="login-page-mantra">
              <p>
                Haven’t registered yet? <br />
                <button
                  type="button"
                  className="login-page-registerlink"
                  onClick={handleRegisterClick}
                >
                  register now
                </button>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileOTPVerify;
